import { Modal } from "antd";
import styled from "styled-components";

export const DivisionTabStyled = styled.div`
  .content-1 {
    .ant-typography {
      color: #fff;
    }

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .title {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 0;
    }

    .main-progress {
      width: 100%;
      margin: 16px 0;
      display: flex;
      gap: 16px;
      align-items: center;
      justify-content: center;

      .ant-typography {
        margin-bottom: 0;
      }

      .ant-progress-line {
        width: 70%;
      }
    }

    .sub-items {
      width: 60%;
      .sub-item {
        gap: 8px;
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: space-between;

        .progress {
          width: 100%;

          .label {
            text-align: right;
            color: #fff;
          }
        }
      }
    }

    .modified {
      color: #ff9500;
      font-size: 20px;
      font-style: italic;
      font-weight: 600;
      line-height: normal;
      margin-bottom: 0;
    }
  }

  .content-2 {
    margin-bottom: 40px;

    .more-info {
      color: #61637a;
      cursor: pointer;

      .anticon {
        color: #61637a;
        font-size: 22px;
      }
    }

    .content-table {
      height: 100%;
      padding: 20px;
      border-radius: 20px;
      border: 1px solid rgba(255, 255, 255, 0.09);

      background: linear-gradient(
          41deg,
          rgba(21, 109, 242, 0) 72.42%,
          #156df2 195.43%
        ),
        #0c0d22;

      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.75);

      .line-progress {
        display: flex;
        gap: 16px;
        text-align: right;
      }

      .tier-row {
        .tier-col {
          width: 100%;
          height: 100px;
          background: linear-gradient(
            0deg,
            rgba(12, 13, 34, 1) 0%,
            rgba(12, 13, 34, 1) 100%
          );
          border-radius: 20px;
          border: 1px solid #ffffff17;
          box-shadow: 0px 4px 4px #00000040;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .tier-name {
            color: #ffffff17;
            font-weight: black;
            font-size: 64px;
            padding-left: 20px;
            min-width: 127px;
          }

          .tier-status {
            width: 200px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
            font-weight: 700;
            text-align: "center";
            border-top-right-radius: 20px;
            border-bottom-right-radius: 20px;
            margin-right: -1.5px;
            border-left: 2px solid #222336;
          }

          &.claim {
            border: 1px solid rgba(255, 255, 255, 0.09);
            background: linear-gradient(
                257deg,
                rgba(255, 149, 0, 0) 72.84%,
                rgba(255, 149, 0, 0.5) 114.23%
              ),
              #0c0d22;
            box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25),
              0px 0px 15.4px 0px #ff9500 inset;
          }

          &.wait-confirm {
            border: 1px solid rgba(255, 255, 255, 0.09);
            background: linear-gradient(
                257deg,
                rgba(21, 109, 242, 0) 72.84%,
                rgba(21, 109, 242, 0.5) 114.23%
              ),
              #0c0d22;
            box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25),
              0px 0px 15.4px 0px #156df2 inset;
          }

          &.lock {
            border: 1px solid rgba(255, 255, 255, 0.09);
            background: linear-gradient(
                257deg,
                rgba(21, 109, 242, 0) 72.84%,
                rgba(21, 109, 242, 0.5) 114.23%
              ),
              #0c0d22;
            box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
          }

          &.nft {
            border: 1px solid rgba(255, 255, 255, 0.09);
            background: linear-gradient(
                257deg,
                rgba(255, 149, 0, 0) 72.84%,
                rgba(255, 149, 0, 0.5) 114.23%
              ),
              #0c0d22;
            box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
          }
        }
      }
    }
  }
`;

export const ModalRulesStyled = styled(Modal)`
  .ant-modal-content {
    background-color: #0c0d22;

    .ant-modal-close {
      display: none;
    }

    .ant-modal-body {
      padding: 0;
    }
  }
`;

export const ModalSuccessStyled = styled(Modal)`
  .ant-modal-content {
    border: 2px solid #222336;
    border-radius: 10px;
    background: transparent;

    .ant-modal-close {
      display: none;
    }

    .ant-modal-body {
      padding: 12px;
      border-radius: 10px;
      background: linear-gradient(
          180deg,
          rgba(21, 109, 242, 0) 66.45%,
          #156df2 143.36%
        ),
        #0c0d22;

      .item-col {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
  }
`;
